import { CompanyActionContext } from '../../../types/CompanyActionContext';

export interface ImportOptionsViewData {
  context: CompanyActionContext;
  editedCompanyId?: string;
  hasStackedFormFields?: boolean;
  shouldHidePartnerImport?: boolean;
  layout?: ImportOptionsLayout;
}

export enum ImportOptionsLayout {
  /**
   * Radio group with two options:
   * - Use data from my company
   * - Use data from a user account (own users)
   */
  SELF_COMPANY_RADIO_GROUP = 'SELF_COMPANY_RADIO_GROUP',

  /**
   * Radio group with two options:
   * - Use data from a company (multiple companies)
   * - Use data from a user account (multiple companies' users)
   */
  ANY_COMPANY_RADIO_GROUP = 'ANY_COMPANY_RADIO_GROUP',

  /**
   * Single option (no radio):
   * - Use data from a user account (own users)
   */
  SELF_ACCOUNT_ONLY = 'SELF_ACCOUNT_ONLY',
}
